export default __webpack_public_path__ + "static/media/green-divider-top.d2a91f5d.svg";